// Course data for "Data Analytics - MS SQL and Power BI"
// This data is used to create the Data Analytics course with interactive components

export const dataAnalyticsCourseData = {
  title: '📊 Data Analytics - MS SQL and Power BI',
  description: 'Master data analytics with Microsoft SQL Server and Power BI! Learn to query databases, create visualizations, build dashboards, and transform data into actionable insights! 🚀✨',
  courseType: 'data-analytics',
  category: 'Data Analytics',
  level: 'intermediate',
  topics: [
    {
      name: '📚 1: Introduction to SQL & Database Fundamentals',
      description: `🎯 What is SQL and relational databases?
✨ Database design principles
💻 Installing SQL Server Management Studio
🎨 Tables, rows, columns, and relationships
🎉 Project: Design your first database schema`,
      hours: 2
    },
    {
      name: '📚 2: SQL Basics - SELECT, WHERE, ORDER BY',
      description: `🔢 SELECT statements and column selection
⌨️ WHERE clause and filtering data
➕ Sorting with ORDER BY
🧮 Basic operators and comparisons
🧮 Project: Query a sample database`,
      hours: 2
    },
    {
      name: '✅ 3: Advanced SQL Queries - JOINs & Aggregations',
      description: `🔀 INNER JOIN, LEFT JOIN, RIGHT JOIN
⚖️ GROUP BY and aggregate functions (COUNT, SUM, AVG)
🧠 HAVING clause
📊 Subqueries and CTEs
🎲 Project: Complex multi-table queries`,
      hours: 2
    },
    {
      name: '✅ 4: SQL Functions & Data Manipulation',
      description: `🔄 String functions (CONCAT, SUBSTRING, REPLACE)
📊 Date functions (GETDATE, DATEDIFF, DATEADD)
✖️ Mathematical functions
📝 CASE statements
✖️ Project: Data transformation queries`,
      hours: 2
    },
    {
      name: '✅ 5: Stored Procedures & Views',
      description: `⚙️ Creating and using stored procedures
♻️ Views for data abstraction
📥 Parameters and variables
🔄 Error handling in SQL
📖 Project: Build reusable SQL components`,
      hours: 2
    },
    {
      name: '🟣 6: Introduction to Power BI',
      description: `🤖 What is Power BI and business intelligence?
🌐 Installing Power BI Desktop
📚 Data sources and connections
🎓 Power BI interface overview
🎯 Project: Connect to your first data source`,
      hours: 2
    },
    {
      name: '📚 7: Power BI Data Modeling & DAX',
      description: `📋 Data model relationships
🤖 DAX (Data Analysis Expressions) basics
📊 Calculated columns vs measures
😊 Common DAX functions
😊 Project: Build a data model with calculations`,
      hours: 2
    },
    {
      name: '🔧 8: Power BI Visualizations & Reports',
      description: `🤖 Creating charts and graphs
🔌 Tables, matrices, and cards
🐍 Maps and geographic visualizations
🖥️ Custom visuals and formatting
🤖 Project: Build your first dashboard`,
      hours: 2
    },
    {
      name: '🔧 9: Advanced Power BI Features',
      description: `⚙️ Power Query for data transformation
📡 Advanced DAX formulas
📝 Drill-through and bookmarks
📦 Publishing and sharing reports
🤖 Project: Create a production-ready dashboard`,
      hours: 2
    },
    {
      name: '🎉 10: End-to-End Analytics Project',
      description: `🎯 Complete analytics project:
🎮 Extract data from SQL Server
🖼️ Transform and model data in Power BI
🖼️ Create interactive dashboards
🤖 Present insights and findings
🎉 Final Project: Real-world analytics solution`,
      hours: 2
    }
  ]
};

// Interactive components to assign at course level
export const dataAnalyticsComponents = [
  'Database Designer',
  'Data Visualizer',
  'API Explorer',
  'Code Editor',
  'Code Challenge',
  'Quiz Master',
  'Virtual Lab',
  'Whiteboard',
  'Portfolio Builder',
  'Progress Tracker'
];

